/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SectionHeader } from 'components/molecules';

const Benefits = ({ data }) => {
  const theme = useTheme();
  return (
    <Box>      
      <SectionHeader
        title={data?.title}
        subtitle={data?.subtitle}
      />

      <Box>
        <Grid container spacing={4}>
          {data?.steps?.map((item, i) => (
            <Grid item xs={12} md={3} key={i}>
              <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                data-aos={'fade-up'}
                data-aos-delay={i * 100}
                data-aos-offset={100}
                data-aos-duration={600}
              >
                <Typography
                  variant={'h3'}
                  gutterBottom
                  align={'center'}
                  color="primary.main"
                  sx={{ fontWeight: 700 }}
                >
                  {item.kpi}
                </Typography>
                <Typography
                  variant={'h5'}
                  gutterBottom
                  align={'center'}
                  sx={{ fontWeight: 700 }}
                >
                  {item.title}
                </Typography>
                <Typography align={'center'} color="text.secondary">{item.description}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Benefits;
